import { Box, styled } from "@mui/material";

export const ImportantText = styled(Box)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightRegular,
}));
